module.exports = __webpack_public_path__ + "img/img-playace.fb4161af.png";